import { render, staticRenderFns } from "./vs-form-number.vue?vue&type=template&id=79fec90a&lang=true"
import script from "./vs-form-number.vue?vue&type=script&lang=js"
export * from "./vs-form-number.vue?vue&type=script&lang=js"
import style0 from "./vs-form-number.vue?vue&type=style&index=0&id=79fec90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports